var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [
        _vm._v("Accelerating deal origination for Africa-focused Investors"),
      ]),
      _vm._v(" "),
      _c(
        "p",
        [
          _c("router-link", { attrs: { to: "/about/deals" } }, [
            _vm._v("Asoko Deal Platform"),
          ]),
          _vm._v(
            " is an exciting extension to the Asoko platform built around one core objective: connecting Investors with pre-qualified African businesses that are actively seeking funding. Asoko supports Investors’ deal-flow through the delivery of digital data and physical deal rooms."
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Asoko’s most recent deal room initiative is in partnership with the UK Department for International Trade, facilitating investment opportunities UK Investors and African corporates"
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openSolutions },
          },
          [_vm._v("Read More")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }